import { render, staticRenderFns } from "./CId.vue?vue&type=template&id=531e599a&scoped=true&"
import script from "./CId.vue?vue&type=script&lang=js&"
export * from "./CId.vue?vue&type=script&lang=js&"
import style0 from "./CId.vue?vue&type=style&index=0&id=531e599a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531e599a",
  null
  
)

export default component.exports